// import axios from "axios";
export default{
    state: {
        frames: null,
        transform: '',
        selected_size: {height: 80, width: 120},
        selected_finition: 'ALU',
        withBackground: false,
        all_coords: [{size: '50x50', coords: [[-0.0787, -0.1286], [0.0136, -0.1395], [0.0136, -0.0348], [-0.0787, -0.0298]]}, {size: '50x75', coords: [[-0.0787, -0.1565], [0.0136, -0.1687], [0.0136, -0.0098], [-0.0787, -0.0063]]}, {size: '75x50', coords: [[-0.1016, -0.1279], [0.0399, -0.1445], [0.0399, -0.0385], [-0.1016, -0.0308]]}, {size: '80x120', coords: [[-0.1061, -0.1992], [0.0454, -0.224], [0.0454, 0.0398], [-0.1061, 0.0414]]}, {size: '100x150', coords: [[-0.1231, -0.2259], [0.0662, -0.2601], [0.0662, 0.0724], [-0.1231, 0.0708]]}, {size: '100x100', coords: [[-0.1223, -0.1726], [0.0652, -0.2001], [0.0652, 0.0176], [-0.1223, 0.0216]]}, {size: '120x80', coords: [[-0.1416, -0.1534], [0.0899, -0.185], [0.0899, -0.0068], [-0.1416, 0.0015]]}, {size: '130x195', coords: [[-0.1464, -0.2623], [0.0962, -0.3127], [0.0962, 0.1199], [-0.1464, 0.1112]]}, {size: '150x150', coords: [[-0.1634, -0.2145], [0.1196, -0.265], [0.1196, 0.0728], [-0.1634, 0.0703]]}, {size: '150x100', coords: [[-0.1659, -0.1688], [0.1234, -0.2116], [0.1234, 0.0143], [-0.1659, 0.0211]]}, {size: '195x195', coords: [[-0.1988, -0.2507], [0.1725, -0.3274], [0.1725, 0.1262], [-0.1988, 0.1124]]}, {size: '195x130', coords: [[-0.1988, -0.1897], [0.1725, -0.2513], [0.1725, 0.0454], [-0.1988, 0.0476]]}],
        coords: [[-0.1061, -0.1992], [0.0454, -0.224], [0.0454, 0.0398], [-0.1061, 0.0414]],
        currentFrame: null,
        currentSlide: 1,
        isUnderEdit: false,
        confortLevel: 0
    },
    mutations: {
        updateConfortLevel(state, payload){
            state.confortLevel = payload
        },
        updateFrames(state, payload){
            state.frames = payload
        },
        updateIsUnderEdit(state, payload){
            state.isUnderEdit = payload
        },
        updateCurrentSlide(state, payload){
            state.currentSlide = payload
        },
        updateCurrentFrame(state, payload){
            state.currentFrame = payload
        },
        updateTransform(state, payload){
            state.transform = payload
        },
        updateSelectedSize(state, payload){
            state.selected_size = {...state.selected_size, ...payload}
        },
        updateCoords(state, payload){
            state.coords = payload
        },
        updateSelectedFinition(state, payload){
            state.selected_finition = payload
        },
        updateWithBackground(state, payload){
            state.withBackground = payload
        },
    },
    actions: {
        // selectSize (context, size){
        //     // const new_coords = context.state.all_coords.filter(x => x.size == `${size.height}x${size.width}`)[0];
        //     // const new_coords = context.state.all_coords.filter(x => x.size == size)[0];
        //     // const new_coords = size.coords;
        //     // console.log(size);
        //     // console.log(size.coords);
            
        // },
        selectConfort (context, level){
            context.commit('updateConfortLevel', level);
            const size = context.state.currentFrame.available_sizes[level];
            context.commit('updateSelectedSize', size);
            context.commit('updateCoords', JSON.parse(JSON.stringify(size.coords)));
        }
    },
   
}